import { FC } from 'react'
import { AdditionalServicesTenants } from 'components/AdditionalServices'
import { UserProtectedRoute } from 'routes'

const AdditionalServicesTenantsPage: FC = () => {
  return (
    <UserProtectedRoute>
      <AdditionalServicesTenants />
    </UserProtectedRoute>
  )
}

export default AdditionalServicesTenantsPage
